// Application root routing tree configuration
import { Routes } from '@angular/router';
import { Shell } from './core/shell/shell';
import { authGuard } from './core/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./core/auth/pages/auth-callback.page').then(m => m.AuthCallbackPage),
    data: { title: 'Autenticação' },
  },
  {
    path: 'acesso-negado',
    loadComponent: () =>
      import('./core/auth/pages/access-denied.page').then(m => m.AccessDeniedPage),
    data: { title: 'Acesso Negado' },
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
      },
      {
        path: 'cadastro',
        loadChildren: () =>
          import('./features/cadastro/cadastro.routes').then(m => m.cadastroRoutes),
        data: { title: 'Cadastro', breadcrumb: 'Cadastro' },
      },
      {
        path: 'tempo-servico',
        loadChildren: () =>
          import('./features/tempo-servico/tempo-servico.routes').then(m => m.tempoServicoRoutes),
        data: {
          title: 'Tempo de Serviço',
          breadcrumb: 'Tempo de Serviço',
        },
      },
      {
        path: 'promocao',
        loadChildren: () =>
          import('./features/promocao/promocao.routes').then(m => m.promocaoRoutes),
        data: {
          title: 'Promoção',
          breadcrumb: 'Promoção',
        },
      },
      {
        path: 'afastamento',
        loadChildren: () =>
          import('./features/afastamento/afastamento.routes').then(m => m.afastamentoRoutes),
        data: {
          title: 'Afastamento',
          breadcrumb: 'Afastamento',
        },
      },
      {
        path: 'movimentacao',
        loadChildren: () =>
          import('./features/movimentacao/movimentacao.routes').then(m => m.movimentacaoRoutes),
        data: {
          title: 'Movimentação',
          breadcrumb: 'Movimentação',
        },
      },
      {
        path: 'organizacao',
        loadChildren: () =>
          import('./features/organizacao/organizacao.routes').then(m => m.organizacaoRoutes),
        data: {
          title: 'Organização',
          breadcrumb: 'Organização',
        },
      },
      {
        path: 'pagamento',
        loadChildren: () =>
          import('./features/pagamento/pagamento.routes').then(m => m.pagamentoRoutes),
        data: {
          title: 'Pagamento',
          breadcrumb: 'Pagamento',
        },
      },
      {
        path: 'assentamentos',
        loadChildren: () =>
          import('./features/assentamentos/assentamentos.routes').then(m => m.assentamentosRoutes),
        data: {
          title: 'Assentamentos',
          breadcrumb: 'Assentamentos',
        },
      },
      {
        path: 'capacitacao',
        loadChildren: () =>
          import('./features/capacitacao/capacitacao.routes').then(m => m.capacitacaoRoutes),
        data: {
          title: 'Capacitação',
          breadcrumb: 'Capacitação',
        },
      },
      {
        path: 'instrutoria',
        loadChildren: () =>
          import('./features/instrutoria/instrutoria.routes').then(m => m.instrutoriaRoutes),
        data: {
          title: 'Instrutoria',
          breadcrumb: 'Instrutoria',
        },
      },
      {
        path: 'mapa-forca',
        loadChildren: () =>
          import('./features/mapa-forca/mapa-forca.routes').then(m => m.mapaForcaRoutes),
        data: {
          title: 'Mapa de Força',
          breadcrumb: 'Mapa de Força',
        },
      },
      {
        path: 'classificacao',
        loadChildren: () =>
          import('./features/classificacao/classificacao.routes').then(m => m.classificacaoRoutes),
        data: {
          title: 'Classificação Funcional',
          breadcrumb: 'Classificação',
        },
      },
      {
        path: 'boletim',
        loadChildren: () =>
          import('./features/boletim/boletim.routes').then(m => m.boletimRoutes),
        data: {
          title: 'Boletim',
          breadcrumb: 'Boletim',
        },
      },
      {
        path: 'aptidao-fisica',
        loadChildren: () =>
          import('./features/aptidao-fisica/aptidao-fisica.routes').then(m => m.aptidaoFisicaRoutes),
        data: {
          title: 'Aptidão Física',
          breadcrumb: 'Aptidão Física',
        },
      },
      {
        path: 'avaliacao-desempenho',
        loadChildren: () =>
          import('./features/avaliacao-desempenho/avaliacao-desempenho.routes').then(m => m.avaliacaoDesempenhoRoutes),
        data: {
          title: 'Avaliação de Desempenho',
          breadcrumb: 'Avaliação de Desempenho',
        },
      },
      {
        path: 'banco-talentos',
        loadChildren: () =>
          import('./features/banco-talentos/banco-talentos.routes').then(m => m.bancoTalentosRoutes),
        data: {
          title: 'Banco de Talentos',
          breadcrumb: 'Banco de Talentos',
        },
      },
      {
        path: 'bem-estar',
        loadChildren: () =>
          import('./features/bem-estar-psicossocial/bem-estar-psicossocial.routes').then(
            m => m.bemEstarRoutes
          ),
        data: {
          title: 'Bem-Estar Psicossocial',
          breadcrumb: 'Bem-Estar',
        },
      },
      {
        path: 'auditoria',
        loadChildren: () =>
          import('./features/auditoria/auditoria.routes').then(m => m.auditoriaRoutes),
        data: {
          title: 'Segurança e Auditoria',
          breadcrumb: 'Auditoria',
        },
      },
      {
        path: 'perfil',
        loadChildren: () =>
          import('./features/perfil/perfil.routes').then(m => m.perfilRoutes),
        data: { title: 'Meu Perfil', breadcrumb: 'Perfil' },
      },
      {
        path: 'wiki-sgp',
        loadChildren: () =>
          import('./features/wiki-sgp/wiki-sgp.routes').then(m => m.wikiRoutes),
        data: { title: 'Wiki SGP', breadcrumb: 'Wiki' },
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings').then(m => m.Settings),
        data: { title: 'Preferências', breadcrumb: 'Preferências' },
      },
      {
        path: 'erro/403',
        loadComponent: () => import('./features/errors/forbidden').then(m => m.Forbidden),
        data: { title: 'Acesso Negado' },
      },
      {
        path: 'erro/500',
        loadComponent: () => import('./features/errors/server-error').then(m => m.ServerError),
        data: { title: 'Erro no Servidor' },
      },
      {
        path: '**',
        loadComponent: () => import('./features/errors/not-found').then(m => m.NotFound),
        data: { title: 'Página não encontrada' },
      },
    ],
  },
];
